<template>
    <div>
        <div v-if="items.length === 0">Your basket is empty.</div>
        <ul v-else class="divide-y divide-gray-200">
            <li v-for="i in items" :key="i.sku" class="flex justify-between items-center py-3">
                <div>
                    <div class="font-medium">{{ i.title }}</div>
                    <div class="text-sm text-gray-500">× {{ i.quantity }}</div>
                </div>
                <div class="flex items-center gap-4">
                    <span class="font-bold">£{{ (i.price * i.quantity).toFixed(2) }}</span>
                    <button @click="remove(i.sku)" class="text-red-600 hover:text-red-800">Remove</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: { initialItems: { type: Array, default: () => [] } },
    data() { return { items: this.initialItems }; },
    methods: {
        async remove(sku) {
            await window.axios.post('/basket/remove', { sku });
            this.items = this.items.filter(i => i.sku !== sku);
            window.dispatchEvent(new CustomEvent('basket-updated'));
        },
    },
};
</script>
